export enum ErrorStatus {
  Forbidden = '403',
  NotFound = '404',
}
